import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  AppService,
  AppDateAdapter,
  APP_DATE_FORMATS
} from "../../../../services/app.service";
import { Order, FieldsToBeDisabledByCountry } from "../../../../models/order.model";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material";
import { MasterService } from "../../../../services/master.service";
import { retry } from "rxjs/operators";

@Component({
  selector: "app-financial-detail",
  templateUrl: "./financial-detail.component.html",
  styleUrls: ["./financial-detail.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    }
  ]
})

export class FinancialDetailComponent implements OnInit {
  @Input() parent: any;
  formGroup: FormGroup;
  formGroupErrors: any;
  translations: any;
  codVal: String = '0';
  codEr: String = '0';
  vatSwisVal: String = '0';
  tranInvoiceVal: String = '0';
  vectorCostVal: String = '0';
  totalCost: String = '0';
  revenue: String = '0';
  defaultVal : any = [];
  skipCalculation : Boolean = true;
  actualCountryCode: String = "";
  fieldsToBeDisabledByCountry: FieldsToBeDisabledByCountry = new FieldsToBeDisabledByCountry();
  fieldsConfiguration : any = [];
  IsFormReady: Boolean = false;

  constructor(private formBuilder: FormBuilder, public appService: AppService, public masterService: MasterService) {
    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
      InvoiceValue: {},
      CashOnDelivery: {},
      CashOnDeliveryCostper: {},
      CashOnDeliveryCosts: {},
      DeliveryCosts: {},
      CustomsFees: {},
      VATSwitzerlandPer: {},
      VATSwitzerland: {},
      TransportInvoice: {},
      CostsSTR: {},
      CostsPF: {},
      CostsCHF: {},
      CostsEURCHF: {},
      Documentcosts: {},
      CostVectors: {},
      Distributorcosts: {},
      Totalcosts: {},
      Revenue: {},
      InvoicenumberHantraco: {},
      PaymentdatetoSSperLB: {}
    };
  }

  ngOnInit() {
    this.loadFormGroup();
    this.bindDefaultVal();
    this.setActualCountryCode();
  }

  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }

  setActualCountryCode(): void {
    
    this.masterService.selectDepotTypeConfig(this.parent.order.D_DistributorId,this.parent.order.C_CountryId).subscribe(
        res => this.selectDepotTypeConfigSuccess(res),
        error => this.apiFaillure(error)
    );
  }

   selectDepotTypeConfigSuccess(res): void {
     
      if (res.Data != null) {
        
        this.fieldsConfiguration = JSON.parse(res.Data);
        //this.actualCountryCode = JSON.parse(res.Data).Table[0].ActualCountryCode;
        this.disableFieldAsPerCountry();
        //this.calculateVal();
      }
   }

  bindDefaultVal(): void {
    this.masterService.selectSysData("ZData", 0).subscribe(
        res => this.bindDefaultValSuccess(res),
        error => this.apiFaillure(error)
    );
  }

  bindDefaultValSuccess(res): void {
    if (res.Data != null) {
      this.defaultVal = JSON.parse(res.Data);
      if(this.defaultVal.length > 0 && typeof this.parent.order.F_VAT == 'undefined'){
        this.parent.order.F_VAT = this.defaultVal[0]["Value"];
      }
      if(this.defaultVal.length > 0 && typeof this.parent.order.F_CODCost == 'undefined'){
        this.parent.order.F_CODCost = this.defaultVal[1]["Value"];
      }
      if(this.defaultVal.length > 0 && typeof this.parent.order.F_V_DocumentCost == 'undefined'){
        this.parent.order.F_V_DocumentCost = this.defaultVal[2]["Value"];
      }
      this.euSettings();
      this.calculateVal();
      this.appService.hideLoading();
    } 
    else {
      this.apiFaillure(res.Message);
    }
  }

  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(
      this.translations.hdError,
      this.translations[error]
    );
  }

  getCODC(pActualPaid, pCODCost){
    let actualPaid: any;
    let codCost: any;
    actualPaid = parseFloat(pActualPaid);
    codCost = parseFloat(pCODCost);
    let returnCalc = ((actualPaid/100) * codCost)
    return returnCalc.toFixed(2);
  }

  euSettings(){
    
    if(this.parent.order.IsEU)
    {
        this.parent.order.F_VAT = 0;
        this.parent.order.F_V_DocumentCost = 0;

        this.formGroup.value.CostVectors = 0;
        this.formGroup.value.CostsEURCHF = 0;
        this.formGroup.value.CostsPF = 0;
        this.formGroup.value.CustomsFees = 0;
        this.formGroup.value.Documentcosts = 0;
        this.formGroup.value.VATSwitzerland = 0;
        this.formGroup.value.VATSwitzerlandPer = 0;

        this.vatSwisVal = '0';
        this.vectorCostVal = '0';


        this.formGroup.controls.CostVectors.disable();
        this.formGroup.controls.CostsEURCHF.disable();
        this.formGroup.controls.CostsPF.disable();
        this.formGroup.controls.CustomsFees.disable();
        this.formGroup.controls.Documentcosts.disable();
        this.formGroup.controls.VATSwitzerland.disable();
        this.formGroup.controls.VATSwitzerlandPer.disable();
    }
  }

  calculate(){
    
    var _p_actualpaid = Number(this.parent.order.P_ActualPaid);

    var _p_paidto = Number(this.parent.order.P_PaidTo);
    var _p_totalamount = Number(this.parent.order.P_TotalAmount);

    var _p_invoicevalue = Number(_p_totalamount);

    var _f_codcost = Number(this.parent.order.F_CODCost);
    var _f_codesamount = Number(this.parent.order.F_CODCAmount);

    var _f_vat = Number(this.parent.order.F_VAT);
    var _f_vatamount = 0;
    var _f_delivercost = Number(this.parent.order.F_DeliverCost);
    var _f_customcost = Number(this.parent.order.F_CustomeCost);
    var _f_transportinvoiceamount = 0;

    var _p_f_v_eurochf = Number(this.parent.order.F_V_EuroCHF);
    var _p_f_v_chfcost = Number(this.parent.order.F_V_CHFCost);

    var _p_f_v_documentcost = Number(this.parent.order.F_V_DocumentCost);

    var _f_costvectoramount = 0;
    var _f_strcost = Number(this.parent.order.F_STRCost);
    var _f_pfcost = Number(this.parent.order.F_PFCost);
    var _f_distributorcost = Number(this.parent.order.F_DistributorCost);
    var _f_totalcost = 0;
    var _f_revenue = 0;

    this.parent.order.P_ActualPaid = Number(_p_actualpaid).toFixed(2);
    this.parent.order.F_InvoiceValue = Number(_p_invoicevalue).toFixed(2);

    if(!this.skipCalculation){
      this.codVal = _p_paidto == 203 ? (0).toFixed(2) : Number((_p_actualpaid / 100) * _f_codcost).toFixed(2);
      this.parent.order.F_CODCAmount = this.codVal;
    }else{
      this.codVal = _p_paidto == 203 ? (0).toFixed(2) : Number(_f_codesamount).toFixed(2);
    }

    this.codEr = _p_paidto == 203 ? (0).toFixed(2) : Number(_p_actualpaid).toFixed(2);
    this.vatSwisVal = Number((_p_totalamount / 100) * _f_vat).toFixed(2);

    this.parent.order.F_VATAmount = this.vatSwisVal;
    this.parent.order.F_TransportInvoiceAmount = (Number(this.codVal) + _f_delivercost + _f_customcost + Number(this.vatSwisVal)).toFixed(2);
    this.tranInvoiceVal = Number(Number(this.codVal) + _f_delivercost + _f_customcost + Number(this.vatSwisVal)).toFixed(2);



    if(_p_f_v_chfcost > 0){
      this.vectorCostVal = Number((_p_f_v_chfcost / _p_f_v_eurochf) + _p_f_v_documentcost).toFixed(2);
    }else{
      this.vectorCostVal = Number(0 + _p_f_v_documentcost).toFixed(2);
    }
    this.parent.order.F_CostVectorAmount = this.vectorCostVal;

    this.totalCost = Number(_f_strcost + _f_pfcost + Number(this.vectorCostVal) + _f_distributorcost).toFixed(2);
    this.parent.order.F_TotalCost = Number(this.totalCost).toFixed(2);

    this.revenue = Number(Number(this.tranInvoiceVal) - Number(this.totalCost)).toFixed(2);
    this.parent.order.F_Revenue = this.revenue;
  }

  calculateVal() {
    this.parent.order.P_ActualPaid = Number(this.parent.order.P_ActualPaid).toFixed(2);
    this.codEr = this.parent.order.P_PaidTo == 203 ? (0).toFixed(2) : Number(this.parent.order.P_ActualPaid).toFixed(2);
    this.parent.order.F_InvoiceValue = this.parent.order.P_TotalAmount;
    
    if(!this.skipCalculation){
      this.codVal = Number(((Number(this.parent.order.P_ActualPaid / 100)) *  Number(this.parent.order.F_CODCost)).toFixed(2)).toString();
      this.codVal = this.parent.order.P_PaidTo == 203 ? (0).toFixed(2) : Number(this.codVal).toFixed(2).toString();
      this.parent.order.F_CODCAmount = this.codVal;
    }else{
      this.codVal = this.parent.order.P_PaidTo == 203 ? (0).toFixed(2) : this.parent.order.F_CODCAmount;
      this.skipCalculation = false;
    }

    this.vatSwisVal = Number(
      ((Number(this.parent.order.P_TotalAmount) / 100) * Number(this.parent.order.F_VAT)).toFixed(2)
    ).toString();
    this.vatSwisVal = Number(this.vatSwisVal).toFixed(2);
    // var tempValue = ((Number(this.parent.order.P_TotalAmount) / 100) * Number(this.parent.order.F_VAT));
    // this.vatSwisVal = tempValue;
    this.parent.order.F_VATAmount = this.vatSwisVal;
    var tInvoiceVal = Number(this.codVal) + Number(this.parent.order.F_DeliverCost) + Number(this.parent.order.F_CustomeCost) + Number(this.vatSwisVal);
    this.tranInvoiceVal = Number(tInvoiceVal).toFixed(2);
    this.parent.order.F_TransportInvoiceAmount = Number(this.tranInvoiceVal).toFixed(2);

    if(Number(this.parent.order.F_V_EuroCHF) > 0)
    {
      this.vectorCostVal = Number(
      (
        (Number(this.parent.order.F_V_CHFCost) / Number(this.parent.order.F_V_EuroCHF)) +
        Number(this.parent.order.F_V_DocumentCost)
      )
      ).toFixed(2);
    }
    else{
      this.vectorCostVal = Number(
        (
          0 + Number(this.parent.order.F_V_DocumentCost)
        ).toFixed(2)
        ).toFixed(2);
    }
    this.parent.order.F_CostVectorAmount = this.vectorCostVal;
    this.totalCost = Number(
      (
        Number(this.parent.order.F_STRCost) +
        Number(this.parent.order.F_PFCost) +
        Number(this.vectorCostVal) +
        Number(this.parent.order.F_DistributorCost)
      ).toFixed(2)
    ).toFixed(2);
    this.parent.order.F_TotalCost = this.totalCost;
    var rev = Number(this.tranInvoiceVal) - Number(this.totalCost);
    this.revenue = Number(rev).toFixed(2);
    this.parent.order.F_Revenue = Number(this.revenue).toFixed(2);
  }

  loadFormGroup() {
    this.formGroup = this.formBuilder.group({
      InvoiceValue:               [{value: "", disabled: true}],
      CashOnDelivery:             [{value: "", disabled: true}],
      CashOnDeliveryCostper:      ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required, ,  Validators.max(100), Validators.min(0)]],
      CashOnDeliveryCosts:        ["", [Validators.max(99999.99),Validators.min(-99999.99)]],
      DeliveryCosts:              ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,  , Validators.max(99999.99),Validators.min(0)]],
      CustomsFees:                ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      VATSwitzerlandPer:          ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required, Validators.max(100),Validators.min(0)]],
      VATSwitzerland:             ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      TransportInvoice:           ["", [Validators.max(99999.99),Validators.min(-99999.99)]],
      CostsSTR:                   ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      CostsPF:                    ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      CostsCHF:                   ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      CostsEURCHF:                ["", [Validators.pattern(/^\-?\d+(\.{1}\d{1,5})?$/),  Validators.max(99.99999),Validators.min(0)]],
      Documentcosts:              ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      CostVectors:                ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      Distributorcosts:           ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      Totalcosts:                 ["", [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99), Validators.min(0)]],
      Revenue:                    ["", [Validators.max(99999.99), Validators.min(-99999.99)]],
      InvoicenumberHantraco:      [],
      PaymentdatetoSSperLB:       []
    });

    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(
        this.formGroup,
        this.formGroupErrors
      );
      this.appService.setFormValid(this.formGroup.invalid);
    });
  }

  disableFieldAsPerCountry(){
    
    var self = this;
    let formGroupControls: any[] = Object.keys(self.formGroup.controls);
    formGroupControls.forEach(function (ctrlName) {
      
        var ctrlConfig = self.fieldsConfiguration.filter(function(item){
          if(item.ControlName == ctrlName){
            return item;
          }
        });

        if(ctrlConfig.length > 0){
          if(ctrlConfig[0].IsActive){
            self.formGroup.controls[ctrlName].enable();  
          }
          else{
            self.formGroup.controls[ctrlName].disable();  
          }
        }
        // if(self.fieldsToBeDisabledByCountry[self.actualCountryCode.toString()].includes(ctrlName))
        //   self.formGroup.controls[ctrlName].enable();
        // else
        //   self.formGroup.controls[ctrlName].disable();
    });
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/financial-detail/financial-detail.component.ts